import {
  DeleteSystemBatchMenuRequest,
  DeleteSystemBatchMenuRequestToJSON,
  HTTPBody,
  RegisterSystemBatchMenuRequest,
  RegisterSystemBatchMenuRequestToJSON,
  SystemBatchMenu,
  SystemBatchMenuFromJSON,
  UpdateSystemBatchMenuRequest,
  UpdateSystemBatchMenuRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemBatchMenuApi extends runtime.BaseAPI {
  /**
   * バッチメニュー一覧取得
   * バッチメニュー一覧を取得する
   */
  async getSystemBatchMenus(): Promise<SystemBatchMenu[]> {
    const response = await this.requestGet(`/system-batch-menus`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemBatchMenuFromJSON)
    ).value()
  }

  /**
   * バッチメニューを取得する
   * バッチメニュー取得
   */
  async getSystemBatchMenu(id: string): Promise<SystemBatchMenu> {
    const response = await this.requestGet(`/system-batch-menus/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemBatchMenuFromJSON(jsonValue)
    ).value()
  }

  /**
   * バッチメニューを登録する
   * バッチメニュー登録
   */
  async registerSystemBatchMenu(
    request: RegisterSystemBatchMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterSystemBatchMenuRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/system-batch-menus',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * バッチメニューを更新する
   * バッチメニュー更新
   */
  async updateSystemBatchMenu(
    request: UpdateSystemBatchMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateSystemBatchMenuRequestToJSON(request)

    const response = await this.requestPut(
      `/system-batch-menus/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * バッチメニューを削除する
   * バッチメニュー削除
   */
  async deleteSystemBatchMenu(
    request: DeleteSystemBatchMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteSystemBatchMenuRequestToJSON(request)

    const response = await this.requestDelete(
      `/system-batch-menus/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
